import React from "react";

export default function VehicleDeliveryAck({ data, loading, children }) {
  return <div>{children}</div>;
}
